import { ApiResponse } from "@roc/feature-app-core";
import { InsuranceAgentService } from "./insuranceAgentService";

export class InsuranceAgentExternalService extends InsuranceAgentService {
  getInsuranceAgentGrid(zipCode: string, page: number, pageSize: number, sortDir: string, sortBy: string, filters: object): Promise<ApiResponse> {
    return this.get('/api/v1/insurance/getInsuranceAgents', { zipCode, page, pageSize, sortDir, sortBy, filters });
  }
}